<template>
  <div class="route-view dark">
    <language-switch />
    <div class="logo">
      <img src="/images/logo.png" />
    </div>
    <div class="panel">
      <div class="section-title">{{ $t('howTo.howToTitle') }}</div>
      <div class="panel-content">
        <div
          class="text-round"
          v-for="(video, index) in videos"
          :key="index"
          @click="showVideo(video)"
          v-show="video.isShow === true"
        >
          <i class="fas fa-play-circle m-r-20"></i>{{ video.title }}
        </div>

        <b-modal :active.sync="videoActive">
          <video width="320" height="auto" controls autoPlay>
            <source :src="videoSelected.video" type="video/mp4" />
          </video>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '@/language'
import LanguageSwitch from '@/components/LanguageSwitch'

export default {
  name: 'UserHelp',
  components: { LanguageSwitch },
  props: {
    page: String
  },
  data() {
    return {
      videoActive: false,
      videoSelected: {},
      videos: [
        // {
        //   title: 'ขั้นตอนการสมัครสมาชิก',
        //   video: '/videos/01_register.mp4',
        //   isShow: true
        // },
        {
          title: i18n.t('howTo.walletTitle'),
          video: '/videos/02_wallet.mp4',
          isShow: true
        },
        {
          title: i18n.t('howTo.playTitle'),
          video: '/videos/03_play.mp4',
          isShow: true
        },
        {
          title: i18n.t('howTo.balanceTitle'),
          video: '/videos/04_balance.mp4',
          isShow: true
        },
        {
          title: i18n.t('howTo.bonusTitle'),
          video: '/videos/05_bonus.mp4',
          isShow: true
        },
        {
          title: i18n.t('howTo.bonusCancelTitle'),
          video: '/videos/06_bonus_cancel.mp4',
          isShow: true
        }
      ]
    }
  },
  created() {
    this.$emit('childinit', this.page)
  },
  methods: {
    showVideo(video) {
      this.videoActive = !this.videoActive
      this.videoSelected = video
    }
  }
}
</script>

<style lang="scss" scoped>
.text-round {
  width: 100%;
  background: white;
  color: $primary;
  padding: 10px 15px;
  margin: 20px 0;
  border-radius: 20px;
  font-size: 18px;

  &:hover {
    background: $light-primary;
    color: white;
    cursor: pointer;
  }
}

/deep/ .modal-content {
  text-align: center;
}
</style>
